export enum AccountActionType {
  BY_UUID_FAILURE = '@@account/BY_UUID_FAILURE',
  BY_UUID_REQUEST = '@@account/BY_UUID_REQUEST',
  BY_UUID_SUCCESS = '@@account/BY_UUID_SUCCESS',

  CREATE_ACCOUNT_DEACTIVATIONS_FAILURE = '@@account/CREATE_ACCOUNT_DEACTIVATIONS_FAILURE',
  CREATE_ACCOUNT_DEACTIVATIONS_REQUEST = '@@account/CREATE_ACCOUNT_DEACTIVATIONS_REQUEST',
  CREATE_ACCOUNT_DEACTIVATIONS_SUCCESS = '@@account/CREATE_ACCOUNT_DEACTIVATIONS_SUCCESS',

  CREATE_FAILURE_CLIENT = '@@account/CREATE_FAILURE_CLIENT',
  CREATE_REQUEST_CLIENT = '@@account/CREATE_REQUEST_CLIENT',
  CREATE_SUCCESS_CLIENT = '@@account/CREATE_SUCCESS_CLIENT',
  DELETE_ACCOUNT_DEACTIVATIONS_FAILURE = '@@account/DELETE_ACCOUNT_DEACTIVATIONS_FAILURE',
  DELETE_ACCOUNT_DEACTIVATIONS_REQUEST = '@@account/DELETE_ACCOUNT_DEACTIVATIONS_REQUEST',

  DELETE_ACCOUNT_DEACTIVATIONS_SUCCESS = '@@account/DELETE_ACCOUNT_DEACTIVATIONS_SUCCESS',
  GET_ALL_DEACTIVATION_FAILURE = '@@account/GET_ALL_DEACTIVATION_FAILURE',
  GET_ALL_DEACTIVATION_REQUEST = '@@account/GET_ALL_DEACTIVATION_REQUEST',

  GET_ALL_DEACTIVATION_SUCCESS = '@@account/GET_ALL_DEACTIVATION_SUCCESS',
  GET_ALL_FAILURE = '@@account/GET_ALL_FAILURE',
  GET_ALL_REQUEST = '@@account/GET_ALL_REQUEST',

  GET_ALL_SELF_SERVICE_FAILURE = '@@account/GET_ALL_SELF_SERVICE_FAILURE',
  GET_ALL_SELF_SERVICE_REQUEST = '@@account/GET_ALL_SELF_SERVICE_REQUEST',
  GET_ALL_SELF_SERVICE_SUCCESS = '@@account/GET_ALL_SELF_SERVICE_SUCCESS',

  GET_ALL_SUCCESS = '@@account/GET_ALL_SUCCESS',
  TOGGLE_CREATE = '@@account/TOGGLE_CREATE',
  TOGGLE_DUPLICATE = '@@account/TOGGLE_DUPLICATE',

  UPDATE_FAILURE_CLIENT = '@@account/UPDATE_FAILURE_CLIENT',
  UPDATE_PAYOUT_SETTINGS_FAILURE_CLIENT = '@@account/UPDATE_PAYOUT_SETTINGS_FAILURE_CLIENT',
  UPDATE_PAYOUT_SETTINGS_REQUEST_CLIENT = '@@account/UPDATE_PAYOUT_SETTINGS_REQUEST_CLIENT',

  UPDATE_PAYOUT_SETTINGS_SUCCESS_CLIENT = '@@account/UPDATE_PAYOUT_SETTINGS_SUCCESS_CLIENT',
  UPDATE_REQUEST_CLIENT = '@@account/UPDATE_REQUEST_CLIENT',
  UPDATE_SUCCESS_CLIENT = '@@account/UPDATE_SUCCESS_CLIENT',
}
